import React, { useState, useEffect } from "react";
import { formatCurrencyVND, formatDate } from "../../utils/helps";
import apiCustom from "../../utils/ApiCustom";

export default function OrderModal({ orderId, onClose }) {
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) {
      getOrder();
    }
  }, []);

  const getOrder = () => {
    apiCustom
      .get(`/order-show-id/${orderId}`)
      .then((res) => {
        setOrder(res.data?.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
      <div className="bg-base-100 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="max-w-4xl mx-auto p-6 bg-base-100 shadow-lg rounded-lg">
          <h2 className="text-2xl font-bold mb-8">Chi tiết giao dịch</h2>

          {/* Danh sách sản phẩm */}
          <div className="space-y-4">
            {order?.details.map((item) => (
              <div
                key={item.id}
                className="flex items-center justify-between border-b pb-4"
              >
                <div className="flex items-center space-x-4">
                  <img
                    src={item?.product?.urlImage[0]}
                    alt="Sản phẩm"
                    className="w-20 h-20 object-cover rounded"
                  />
                  <div>
                    <h3 className="text-lg font-semibold">
                      {item?.product?.name}
                    </h3>
                    <p className="text-gray-500">Số lượng: {item.quantity}</p>
                    {item.coupon && (
                      <p className="text-gray-500">
                        Mã thưởng: {item.coupon?.code} (-{" "}
                        {formatCurrencyVND(item.coupon?.price)})
                      </p>
                    )}
                    {item.recordedGift &&
                      Number(item.recordedGiftCondition) && (
                        <div className="flex items-center animate-rgb-glow">
                          <label className="font-medium text-sm">
                            {item.recordedGift}
                          </label>
                        </div>
                      )}
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  {/* {item.coupon && item.quantity == 1 ? (
                    <p className="text-gray-500">
                      Giá:{" "}
                      {formatCurrencyVND(
                        item.recordedPrice - item.coupon.price
                      )}
                    </p>
                  ) : (
                    <p className="text-gray-500">
                      Giá:{" "}
                      {formatCurrencyVND(item.product.price * item.quantity)}
                    </p>
                  )} */}
                  <p className="text-gray-500">
                    Giá: {formatCurrencyVND(Number(item.recordedPrice))}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Tổng tiền */}
          <div className="mt-6 flex justify-between">
            <div>
              <div className="mt-2">
                <p className="text-lg font-semibold">Tên: {order?.fullName}</p>
              </div>
              <p className="text-lg font-semibold mt-2">
                Email: {order?.email}
              </p>
              <div className="mt-2">
                <p className="text-lg font-semibold">
                  Địa chỉ: {order?.address}
                </p>
              </div>
              <div className="mt-2">
                <p className="text-lg font-semibold">
                  Ngày đặt hàng: {formatDate(order?.createdAt)}
                </p>
              </div>
              <div className="mt-2">
                <p className="text-lg font-semibold">Ghi chú: {order?.note}</p>
              </div>
            </div>

            <p className="text-lg font-semibold">
              Tổng tiền: {formatCurrencyVND(Number(order?.totalPrice))}
            </p>
          </div>

          {/* Nút thao tác */}
          <div className="mt-6 flex justify-end gap-4">
            <button
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              onClick={onClose}
            >
              Đóng
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
